import { siteStats } from '@/mocks/stats';

export default function StatBar() {
  return (
    <section className="bg-foreground-950 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-5">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {siteStats.map((stat, index) => (
            <div
              key={stat.id}
              className={`flex items-center gap-3 ${index > 0 ? 'md:border-l md:border-background-800 md:pl-6' : ''}`}
            >
              <span className="w-10 h-10 rounded-md bg-background-800 text-primary-400 flex items-center justify-center text-xl">
                <i className={stat.icon}></i>
              </span>
              <div>
                <div className="font-heading font-bold text-xl text-background-50 leading-none">
                  {stat.value}
                  <span className="text-xs ml-1 text-background-300 font-body">{stat.unit}</span>
                </div>
                <div className="mt-1 text-xs text-background-300">{stat.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}